var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('i', {
      class: 'iconfont ' + item.icon
    }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.children[0].name))])])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden && item.children && item.children.length > 0) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: 'iconfont ' + item.icon
    }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "nest-menu",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(child.icon) ? _c('i', {
        class: 'iconfont ' + child.icon
      }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(child.name))])])], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4b2782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 9JXx
// module chunks = 49